(function () {
  if (customElements.get('model-picker')) return;

  var squish = function (s) { return s.split(' ').join('').split('-').join(''); };

  var scrollBehavior = function () {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
  };

  // ---- Name parsing -----------------------------------------------------
  // Turns a model name into the series a shopper filters by. Apple uses name
  // suffixes (Pro / Plus / Air / mini), most Android brands use a letter+number
  // code (S24, A54, V29, F25), and some use a family word (Note, Reno, GT).
  // `word: true` means the family must appear as its own word, so short codes
  // like GT never match inside another word.

  var FAMILIES = [
    { match: 'z fold', label: 'Z Fold' },
    { match: 'z flip', label: 'Z Flip' },
    { match: 'note', label: 'Note', word: true },
    { match: 'reno', label: 'Reno', word: true },
    { match: 'nord', label: 'Nord', word: true },
    { match: 'narzo', label: 'Narzo', word: true },
    { match: 'find', label: 'Find', word: true },
    { match: 'razr', label: 'Razr', word: true },
    { match: 'pixel', label: 'Pixel', word: true },
    { match: 'magic', label: 'Magic', word: true },
    { match: 'nova', label: 'Nova', word: true },
    { match: 'edge', label: 'Edge', word: true },
    { match: 'gt', label: 'GT', word: true },
    { match: 'fold', label: 'Fold', word: true },
    { match: 'flip', label: 'Flip', word: true },

    // Desktop Macs: without these, "Mac Mini M4" reads as "M Series".
    { match: 'mac mini', label: 'Mac Mini' },
    { match: 'mac studio', label: 'Mac Studio' },
    { match: 'imac', label: 'iMac', word: true },

    // Laptops group by product line, not by a number code. These must be
    // checked before the letter+digit rule, or "Elitebook 745 G7" would be
    // read as "G Series".
    { match: 'elitebook', label: 'EliteBook', word: true },
    { match: 'probook', label: 'ProBook', word: true },
    { match: 'pavilion', label: 'Pavilion', word: true },
    { match: 'spectre', label: 'Spectre', word: true },
    { match: 'envy', label: 'Envy', word: true },
    { match: 'omen', label: 'Omen', word: true },
    { match: 'victus', label: 'Victus', word: true },
    { match: 'chromebook', label: 'Chromebook', word: true },
    { match: 'zbook', label: 'ZBook', word: true },
    { match: 'inspiron', label: 'Inspiron', word: true },
    { match: 'latitude', label: 'Latitude', word: true },
    { match: 'vostro', label: 'Vostro', word: true },
    { match: 'precision', label: 'Precision', word: true },
    { match: 'alienware', label: 'Alienware', word: true },
    { match: 'xps', label: 'XPS', word: true },
    { match: 'thinkpad', label: 'ThinkPad', word: true },
    { match: 'thinkbook', label: 'ThinkBook', word: true },
    { match: 'ideapad', label: 'IdeaPad', word: true },
    { match: 'legion', label: 'Legion', word: true },
    { match: 'yoga', label: 'Yoga', word: true },
    { match: 'vivobook', label: 'VivoBook', word: true },
    { match: 'zenbook', label: 'ZenBook', word: true },
    { match: 'proart', label: 'ProArt', word: true },
    { match: 'tuf', label: 'TUF', word: true },
    { match: 'rog', label: 'ROG', word: true },
    { match: 'aspire', label: 'Aspire', word: true },
    { match: 'nitro', label: 'Nitro', word: true },
    { match: 'predator', label: 'Predator', word: true },
    { match: 'swift', label: 'Swift', word: true },
    { match: 'travelmate', label: 'TravelMate', word: true },
    { match: 'extensa', label: 'Extensa', word: true },

    // Last: the generic line. Without it, "HP Notebook 15s-BS644TU" falls to
    // the letter+digit rule and invents a pill per SKU prefix (BS, DA, DU...).
    { match: 'notebook', label: 'Notebook', word: true }
  ];

  var BRANDS = {
    samsung: 'Samsung', galaxy: 'Galaxy', vivo: 'Vivo', oppo: 'Oppo',
    realme: 'Realme', redmi: 'Redmi', xiaomi: 'Xiaomi', poco: 'Poco',
    oneplus: 'OnePlus', iqoo: 'iQOO', motorola: 'Motorola', moto: 'Moto',
    nothing: 'Nothing', google: 'Google', honor: 'Honor', huawei: 'Huawei',
    infinix: 'Infinix', tecno: 'Tecno', lava: 'Lava', nokia: 'Nokia',
    asus: 'Asus', rog: 'ROG', itel: 'Itel', micromax: 'Micromax', apple: 'Apple'
  };

  var isDigit = function (c) { return c >= '0' && c <= '9'; };
  var isLetter = function (c) { return c >= 'a' && c <= 'z'; };

  var tokenize = function (raw) {
    var lower = String(raw).toLowerCase();
    var cleaned = '';

    for (var i = 0; i < lower.length; i++) {
      var ch = lower.charAt(i);
      cleaned += '()-_,/+'.indexOf(ch) > -1 ? ' ' : ch;
    }

    var tokens = cleaned.split(' ').filter(function (t) { return t.length > 0; });
    var padded = ' ' + tokens.join(' ') + ' ';

    return {
      tokens: tokens,
      has: function (w) { return padded.indexOf(' ' + w + ' ') > -1; },
      contains: function (w) { return padded.indexOf(w) > -1; }
    };
  };

  // A budget variant written as digits plus a trailing letter, e.g. 17e, 12x.
  var budgetSuffix = function (tokens) {
    for (var i = 0; i < tokens.length; i++) {
      var t = tokens[i];
      if (t.length < 2 || t.length > 4) continue;
      if (!isDigit(t.charAt(0))) continue;

      var last = t.charAt(t.length - 1);
      if (isLetter(last) && last !== 'g') return true;
    }

    return false;
  };

  var detectSeries = function (raw) {
    var p = tokenize(raw);
    var has = p.has;
    var contains = p.contains;
    var i;

    if (contains('macbook')) {
      if (has('pro')) return 'MacBook Pro';
      if (has('air')) return 'MacBook Air';
      return 'MacBook';
    }

    if (contains('ipad')) {
      if (has('pro')) return 'iPad Pro';
      if (has('air')) return 'iPad Air';
      if (has('mini')) return 'iPad mini';
      return 'iPad';
    }

    if (contains('iphone')) {
      if (contains('pro max')) return 'Pro Max';
      if (has('pro')) return 'Pro';
      if (has('air')) return 'Air';
      if (has('plus')) return 'Plus';
      if (has('mini')) return 'Mini';
      if (has('se')) return 'SE';
      return 'Standard';
    }

    if (contains('watch')) return 'Watch';

    for (i = 0; i < FAMILIES.length; i++) {
      var f = FAMILIES[i];
      if (f.word ? has(f.match) : contains(f.match)) return f.label;
    }

    // Letter+number model code, e.g. S24 Ultra, A54, V29e, F25, C55, GT7.
    for (i = 0; i < p.tokens.length; i++) {
      var t = p.tokens[i];
      if (BRANDS[t]) continue;

      var letters = 0;
      while (letters < t.length && isLetter(t.charAt(letters))) letters++;

      if (letters > 0 && letters <= 3 && letters < t.length && isDigit(t.charAt(letters))) {
        return t.slice(0, letters).toUpperCase() + ' Series';
      }
    }

    // Purely numbered flagship, e.g. OnePlus 12 or Realme 11 Pro.
    for (i = 0; i < p.tokens.length; i++) {
      if (BRANDS[p.tokens[i]]) return BRANDS[p.tokens[i]];
    }

    return 'Other';
  };

  // Models that share one numbering run belong to the same line, so every
  // iPhone 17 variant sorts together instead of sitting in separate blocks.
  // Android numbering restarts per series, so each series stays its own line.
  var detectLine = function (raw, seriesKey) {
    var p = tokenize(raw);

    if (p.contains('iphone')) return 'apple-iphone';
    if (p.contains('ipad')) return 'apple-ipad';
    if (p.contains('macbook')) return 'apple-macbook';
    if (p.contains('watch')) return 'apple-watch';

    return seriesKey || 'other';
  };

  // Generation number used to sort newest first: S26 -> 26, iPhone 13 -> 13.
  // A release year stands in for models named after one, so SE (2022) lands
  // beside the 13 rather than at the very top.
  var detectGeneration = function (raw) {
    var p = tokenize(raw);
    var tokens = p.tokens;

    for (var i = 0; i < tokens.length; i++) {
      var t = tokens[i];
      if (BRANDS[t]) continue;

      var j;
      var digits = '';

      // Leading digits: 13, 17e, 12x.
      if (isDigit(t.charAt(0))) {
        for (j = 0; j < t.length && isDigit(t.charAt(j)); j++) digits += t.charAt(j);

        var value = parseInt(digits, 10);
        if (value >= 1990 && value <= 2100) return value - 2009;
        if (value > 0 && value <= 40) return value;
        continue;
      }

      // Letter code then digits: s26, a54, v29.
      var letters = 0;
      while (letters < t.length && isLetter(t.charAt(letters))) letters++;

      if (letters > 0 && letters <= 3 && letters < t.length && isDigit(t.charAt(letters))) {
        for (j = letters; j < t.length && isDigit(t.charAt(j)); j++) digits += t.charAt(j);
        return parseInt(digits, 10);
      }
    }

    if (p.has('xs') || p.has('xr') || p.has('x')) return 10;
    if (p.has('se')) return 9;

    return 0;
  };

  // Within one generation the bigger model comes first:
  // Ultra / Pro Max, Pro, Air, Plus, base, e / FE / Lite, mini.
  var detectRank = function (raw) {
    var p = tokenize(raw);

    if (p.has('ultra')) return 12;
    if (p.contains('pro max')) return 12;
    if (p.has('pro')) return 10;
    if (p.has('max')) return 10;
    if (p.has('air')) return 9;
    if (p.has('plus')) return 8;
    if (p.has('fe') || p.has('lite')) return 4;
    if (budgetSuffix(p.tokens)) return 4;
    if (p.has('mini')) return 2;

    return 6;
  };

  // Laptop model numbers are screen sizes and SKU codes, not generations, so
  // sorting them newest-first is meaningless. These lines sort A to Z instead,
  // which reads naturally: Elitebook 745 G7, 840 G7, 840 G8, 845 G7.
  var LAPTOP_LINES = {
    'EliteBook': 1, 'ProBook': 1, 'Pavilion': 1, 'Spectre': 1, 'Envy': 1,
    'Omen': 1, 'Victus': 1, 'Chromebook': 1, 'ZBook': 1, 'Inspiron': 1,
    'Latitude': 1, 'Vostro': 1, 'Precision': 1, 'Alienware': 1, 'XPS': 1,
    'ThinkPad': 1, 'ThinkBook': 1, 'IdeaPad': 1, 'Legion': 1, 'Yoga': 1,
    'VivoBook': 1, 'ZenBook': 1, 'ProArt': 1, 'TUF': 1, 'ROG': 1,
    'Aspire': 1, 'Nitro': 1, 'Predator': 1, 'Swift': 1, 'TravelMate': 1,
    'Extensa': 1, 'Notebook': 1
  };

  var slug = function (s) { return s.toLowerCase().split(' ').join('-'); };

  window.ModelPickerSeries = {
    detect: detectSeries,
    line: detectLine,
    generation: detectGeneration,
    rank: detectRank
  };

  // ---- Element ----------------------------------------------------------

  customElements.define('model-picker', class extends HTMLElement {
    connectedCallback() {
      this.rows = Array.prototype.slice.call(this.querySelectorAll('.mp__row'));
      this.grid = this.querySelector('.mp__grid');
      this.toolbar = this.querySelector('.mp__toolbar');
      this.pillWrap = this.querySelector('.mp__pills');
      this.input = this.querySelector('.mp__search');
      this.clearBtn = this.querySelector('.mp__clear');
      this.countEl = this.querySelector('[data-mp-count]');
      this.fab = this.querySelector('.mp__fab');
      this.topBtn = this.querySelector('[data-mp-top]');
      this.jumpBtn = this.querySelector('[data-mp-jump]');
      this.group = '';
      this.seriesOrder = {};

      this.rows.forEach(function (r) {
        var name = r.getAttribute('data-name') || '';
        var series = detectSeries(name);
        r.squished = squish(name);
        r.generation = LAPTOP_LINES[series] ? 0 : detectGeneration(name);
        r.rank = LAPTOP_LINES[series] ? 6 : detectRank(name);
        r.seriesKey = slug(series);
        r.lineKey = detectLine(name, r.seriesKey);
      });

      if (this.getAttribute('data-auto-series') === 'true') this.buildSeriesPills();
      if (this.getAttribute('data-sort') !== 'false') this.sortRows();

      this.pills = Array.prototype.slice.call(this.querySelectorAll('.mp__pill'));

      if (this.input) {
        this.input.addEventListener('input', this.apply.bind(this));
        this.input.addEventListener('keydown', this.onKey.bind(this));
      }

      if (this.clearBtn) {
        this.clearBtn.addEventListener('click', function () {
          this.input.value = '';
          this.input.focus();
          this.apply();
        }.bind(this));
      }

      this.pills.forEach(function (p) {
        p.addEventListener('click', function () {
          this.group = p.getAttribute('data-group') || '';
          this.pills.forEach(function (o) { o.setAttribute('aria-pressed', o === p ? 'true' : 'false'); });
          this.apply();
        }.bind(this));
      }.bind(this));

      if (this.topBtn) {
        this.topBtn.addEventListener('click', function () {
          window.scrollTo({ top: 0, behavior: scrollBehavior() });
        });
      }

      if (this.jumpBtn) {
        this.jumpBtn.addEventListener('click', function () {
          var behavior = scrollBehavior();
          if (this.toolbar) this.toolbar.scrollIntoView({ behavior: behavior, block: 'start' });
          if (this.input) {
            var input = this.input;
            window.setTimeout(function () { input.focus({ preventScroll: true }); }, behavior === 'smooth' ? 420 : 0);
          }
        }.bind(this));
      }

      this.observe();
      this.watchFab();
      this.apply();
    }

    // Reads the model names actually present and creates one pill per series.
    buildSeriesPills() {
      if (!this.pillWrap || this.rows.length === 0) return;

      var max = parseInt(this.getAttribute('data-max-pills'), 10) || 8;
      var counts = {};
      var labels = {};

      this.rows.forEach(function (r) {
        var label = detectSeries(r.getAttribute('data-name'));
        var key = slug(label);
        labels[key] = label;
        counts[key] = (counts[key] || 0) + 1;
      });

      var keys = Object.keys(counts).sort(function (a, b) {
        if (counts[b] !== counts[a]) return counts[b] - counts[a];
        return labels[a] < labels[b] ? -1 : 1;
      });

      // A single series means nothing to filter by.
      if (keys.length < 2) {
        this.pillWrap.hidden = true;
        return;
      }

      var kept = keys.slice(0, max);
      var self = this;

      kept.forEach(function (k, i) { self.seriesOrder[k] = i; });

      this.rows.forEach(function (r) {
        r.setAttribute('data-group', kept.indexOf(r.seriesKey) > -1 ? r.seriesKey : '');
      });

      var allLabel = this.getAttribute('data-all-label') || 'All';
      var html = '<button type="button" class="mp__pill" data-group="" aria-pressed="true">' + allLabel +
        '<span class="mp__pill-count">' + this.rows.length + '</span></button>';

      kept.forEach(function (k) {
        html += '<button type="button" class="mp__pill" data-group="' + k + '" aria-pressed="false">' +
          labels[k] + '<span class="mp__pill-count">' + counts[k] + '</span></button>';
      });

      this.pillWrap.innerHTML = html;
    }

    // Newest first inside each numbering line, so an iPhone page reads
    // 17 Pro Max, 17 Pro, 17 Air, 17, 17e, 16 Pro Max... and a Samsung page
    // keeps its S and A runs apart because their numbers are unrelated.
    sortRows() {
      if (!this.grid || this.rows.length < 2) return;

      var order = this.seriesOrder;
      var lineRank = {};
      var last = 999;

      this.rows.forEach(function (r) {
        var idx = order[r.seriesKey];
        if (idx === undefined) idx = last;
        if (lineRank[r.lineKey] === undefined || idx < lineRank[r.lineKey]) {
          lineRank[r.lineKey] = idx;
        }
      });

      var sorted = this.rows.slice().sort(function (a, b) {
        var la = lineRank[a.lineKey];
        var lb = lineRank[b.lineKey];

        if (la !== lb) return la - lb;
        if (a.generation !== b.generation) return b.generation - a.generation;
        if (a.rank !== b.rank) return b.rank - a.rank;

        return a.squished < b.squished ? -1 : 1;
      });

      var frag = document.createDocumentFragment();
      sorted.forEach(function (r) { frag.appendChild(r); });

      this.grid.appendChild(frag);
      this.rows = sorted;
    }

    observe() {
      if (!this.classList.contains('mp--animate')) return;

      if (!('IntersectionObserver' in window)) {
        this.rows.forEach(function (r) { r.classList.add('is-in'); });
        return;
      }

      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.classList.add('is-in');
            io.unobserve(e.target);
          }
        });
      }, { rootMargin: '0px 0px -6% 0px', threshold: 0.05 });

      this.rows.forEach(function (r) { io.observe(r); });
    }

    watchFab() {
      if (!this.fab || !this.grid) return;

      var self = this;
      var ticking = false;

      this.updateFab = function () {
        ticking = false;

        var grid = self.grid.getBoundingClientRect();
        var anchor = (self.toolbar || self.grid).getBoundingClientRect();
        var inView = grid.top < window.innerHeight && grid.bottom > 0;
        var past = anchor.bottom < 0;

        self.setAttribute('data-fab', inView && past ? 'true' : 'false');
      };

      var request = function () {
        if (!ticking) {
          ticking = true;
          window.requestAnimationFrame(self.updateFab);
        }
      };

      window.addEventListener('scroll', request, { passive: true });
      window.addEventListener('resize', request, { passive: true });

      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(request, { threshold: [0, 0.01, 1] });
        io.observe(this.grid);
        if (this.toolbar) io.observe(this.toolbar);
      }

      this.updateFab();
    }

    apply() {
      var raw = this.input ? this.input.value.trim().toLowerCase() : '';
      var q = squish(raw);
      var group = this.group;
      var visible = 0;
      var i = 0;

      this.rows.forEach(function (r) {
        var okText = !q || r.squished.indexOf(q) !== -1;
        var okGroup = !group || r.getAttribute('data-group') === group;
        var show = okText && okGroup;
        r.hidden = !show;
        if (show) {
          r.style.setProperty('--i', Math.min(i, 24));
          if (q || group) r.classList.add('is-in');
          i++;
          visible++;
        }
      });

      this.setAttribute('data-empty', visible === 0 ? 'true' : 'false');
      this.setAttribute('data-has-query', raw ? 'true' : 'false');
      if (this.countEl) this.countEl.textContent = visible;
    }

    onKey(event) {
      if (event.key === 'Escape') {
        this.input.value = '';
        this.apply();
        return;
      }

      var visibleRows = this.rows.filter(function (r) { return !r.hidden; });

      if (event.key === 'Enter' && visibleRows[0]) {
        event.preventDefault();
        window.location.href = visibleRows[0].getAttribute('href');
        return;
      }

      if (event.key === 'ArrowDown' && visibleRows[0]) {
        event.preventDefault();
        visibleRows[0].focus();
      }
    }
  });
})();
